function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelClockCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "travel_x5F_clock_x5F_calendar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32.062",
    style: {
      enableBackground: "new 0 0 32 32.062"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M22,32c-5.514,0-10-4.486-10-10s4.486-10,10-10s10,4.486,10,10S27.514,32,22,32z M22,14 c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S26.411,14,22,14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "26,23 21,23 21,18 23,18 23,21 26,21  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 30.062,
    style: {
      fill: "#FD5C3F"
    },
    width: 12,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 26,
    style: {
      fill: "#FD5C3F"
    },
    width: 10,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 2,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2,
    style: {
      fill: "#FD5C3F"
    },
    width: 30,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 2,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 6,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelClockCalendar);
export default __webpack_public_path__ + "static/media/travel_clock_calendar.fe69f8a22ea14ceb5d781caff26ded39.svg";
export { ForwardRef as ReactComponent };